// Role configuration using role IDs from database
// Role ID mapping: 1=Admin, 2=National, 3=State, 4=Mentoring institute, 5=DCCC
export const ROLES = {
  ADMIN: 1,
  NATIONAL: 2,
  STATE: 3,
  MEDICAL_INSTITUTE: 4,
  DCCC: 5,
};

// Define what each role can access
export const rolePermissions = {
  [ROLES.MEDICAL_INSTITUTE]: {
    pages: ["dashboard", "beneficiaryManagement", "treatmentModule", "patientRegistration", "miTreatmentProcedure", "profileView"],
    actions: { create: true, edit: true, delete: true, export: true },
    dashboard: "Dashboard",
    dashboardPath: "dashboard", // Path to redirect to
  },
  [ROLES.DCCC]: {
    pages: ["moDashboard", "moBeneficiaryManagement", "appointmentManagement", "treatmentProcedure", "treatmentProcedureStep", "profileView", "hrManagement"],
    actions: { create: true, edit: true, delete: true, export: true },
    dashboard: "Dashboradmo",
    dashboardPath: "moDashboard", // Path to redirect to
  },
  [ROLES.ADMIN]: {
    pages: ["adminDashboard", "adminStatewiseStats", "profileView"],
    actions: { create: false, edit: false, delete: false, export: true },
    dashboard: "AdminDashboard",
    dashboardPath: "adminDashboard", // Path to redirect to
  },
  [ROLES.STATE]: {
    pages: ["dashboard", "treatmentModule", "profileView"],
    actions: { create: false, edit: false, delete: false, export: true },
    dashboard: "Dashboard",
    dashboardPath: "dashboard", // Path to redirect to
  },
  [ROLES.NATIONAL]: {
    pages: ["dashboard", "appointmentManagement", "profileView"],
    actions: { create: false, edit: false, delete: false, export: true },
    dashboard: "Dashboard",
    dashboardPath: "dashboard", // Path to redirect to
  },
};

// Simple helper functions
export const canAccessPage = (role, page) => {
  return rolePermissions[role]?.pages.includes(page) || false;
};

export const canDoAction = (role, action) => {
  return rolePermissions[role]?.actions[action] || false;
};

export const getDashboard = (role) => {
  return rolePermissions[role]?.dashboard || "GenericDashboard";
};

export const getDashboardPath = (role) => {
  return rolePermissions[role]?.dashboardPath || "dashboard";
};